import { Box, Card, CardContent, Typography } from '@mui/material';
import React, { FunctionComponent } from 'react';

import { useCurrentEventQuery } from '../hooks/useCurrentEventQuery';

interface HeaderCardProps {
  description?: string;
  title?: string;
}

export const HeaderCard: FunctionComponent<HeaderCardProps> = ({
  description = null,
  title,
}) => {
  const { data: currentEventData } = useCurrentEventQuery();
  const currentEvent = currentEventData?.currentEvent ?? null;

  const resolvedTitle =
    title ??
    (currentEvent === null
      ? 'Aucun événement pour le moment'
      : currentEvent.name);
  const resolvedDescription =
    currentEvent === null
      ? 'Veuillez réessayer plus tard lorsque des événements auront été ajoutés.'
      : description;

  return (
    <Card
      sx={{
        mb: 2,
        borderRadius: 3,
        background:
          'linear-gradient(135deg, rgba(25,118,210,0.12) 0%, rgba(25,118,210,0.02) 100%)',
      }}
    >
      <CardContent>
        <Box>
          <Typography variant="h4" gutterBottom>
            {resolvedTitle}
          </Typography>
          {resolvedDescription ? (
            <Typography variant="body1" color="text.secondary">
              {resolvedDescription}
            </Typography>
          ) : null}
        </Box>
      </CardContent>
    </Card>
  );
};
